import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnInit,
} from '@angular/core';
import {
    APP_CONSTANTS_CONFIG,
    ResolveValue,
} from '../../../../pipes/app-constants.pipe';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'pf-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent implements OnInit {
    @Input() pageTitle!: string;
    @Input() pageSubtitle!: string;
    @Input() hideBreadcrumbs = false;

    private _appConstants = inject(APP_CONSTANTS_CONFIG);
    routeLabelFn = (routeLabel: string) =>
        ResolveValue(routeLabel, this._appConstants);

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.route.params.subscribe(() => {
            this.router.config;
        });
    }
}
